import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption, RoomExtraOptionPerDateTimeRangeType } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

const optionsForPerDateTimeRange = (options: RoomExtraOptionPerDateTimeRangeType[]) =>
  options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const dateString = startDate === endDate ? startDate : `${startDate} - ${endDate}`;
    return {
      label: `${dateString} : ${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(
        0,
        5
      )}`,
      value: index,
    };
  });

type SelectOption = { label: string; value: number };

export const PerDateTimeRange = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const opts = optionsForPerDateTimeRange(options as RoomExtraOptionPerDateTimeRangeType[]);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
